<template>

<app-content :loading="is.loading">

	<app-content-body v-if="!is.loading" :is-call="true">

		<app-content-call :loading="is.confirming" icon="approve" theme="green" title="Accept Submission" text="The submission will be scheduled for attendees to see." :has-cancel="true" button="Confirm" v-on:click="onConfirmClick" v-on:cancel="onCancelClick">

			<div class="suggestion">

				<div class="suggestion-item is-name"><small>Name</small>{{ suggestion.name }}</div>
				<div class="suggestion-item"><small>Day</small>{{ $con.schedule.days[suggestion.day] }}</div>
				<div class="suggestion-item"><small>Starts</small>{{ $con.schedule.times[suggestion.time] }}</div>
				<div class="suggestion-item"><small>Ends</small>{{ $con.schedule.times[suggestion.time + suggestion.duration] }}</div>

			</div>

			<app-input-checklist class="suggestion-input" :fullWidth="true" :singular="true" :columns="1" v-model="model.schedule" :options="$constants.schedule.suggestions.accept[(isApplication) ? 'applicant' : 'attendee'].scheduleName" :descriptions="$constants.schedule.suggestions.accept[(isApplication) ? 'applicant' : 'attendee'].scheduleDescription" />

		</app-content-call>
	
	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {

		return {
			is: {
				loading: true,
				confirming: false
			},
			model: {
				schedule: 1
			},
			suggestion: {},
			space: {}
		}

	},

	created: function() {

		this.load();

	},

	computed: {
	
		isApplication: function() {
		
			return this.suggestion.application
		
		}

	},

	methods: {

		onCancelClick: function() {

			this.$router.push({
				name: 'Convention.Schedule.Suggestions.Edit'
			})

		},

		onConfirmClick: async function() {

			this.is.confirming = true

			this.$api.post('convention/schedule/suggestion/' + this.$route.params.id + '/accept', this.model).then(function() {

				this.$notify({
					message: 'The submission has been approved!'
				})

				this.$router.push({
                    name: 'Convention.Schedule.Suggestions.Edit'
				})

            }.bind(this))

		},

		load: function() {

			this.$api.get('convention/schedule/suggestion/' + this.$route.params.id + '/accept').then(function(response) {

				Vue.set(this, 'suggestion', response.suggestion)
				Vue.set(this, 'space', response.space)
				
				this.model.seats = this.space.seats

				this.is.loading = false

			}.bind(this), function() {
            
                this.$notify({
					message: 'This is not a pending submission.',
					type: 'error'
				})

				this.$router.push({
                    name: 'Convention.Schedule.Suggestions.Edit'
				})
            
            }.bind(this))

		}

	}

}

</script>

<style scoped>

.suggestion {
	display: flex;
	margin: 20px 0px;
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 10px;
	width: 100%;
}

.suggestion-item {
	padding: 10px 20px;
	flex-shrink: 0;
	font-weight: 400;
	font-size: 16px;
}

.suggestion-item.is-name {
	flex-grow: 1;
}

.suggestion-item small {
	display: block;
	font-weight: 300;
	font-size: 12px;
	color: #666;
	margin-bottom: 2px;
}

.suggestion.is-empty {
	padding: 20px;
    align-items: center;
    justify-content: center;
    margin: 0px;
    background-color: #dd4848;
    border: 0px;
    color: #fff;
    font-weight: 400;
}

.suggestion-input {
	width: 100%;
}

</style>
